import Validator from "validator";
export default function(toValidate) {
    //do not need to check undefined and null
    if (!toValidate || toValidate === "") {
        return true;
    }
    return Validator.isUppercase(toValidate);
}
